
import { includesValidator } from '../../common/utils/validator';

const View = {
  Text: 'text',
  Tag: 'tag',
  Point: 'point',
};

const Status = {
  Activated: 'activated',
  Approved: 'approved',
  Success: 'success',
  Primary: 'primary',
  Deployed: 'deployed',
  InReview: 'in-review',
  Warning: 'warning',
  Expired: 'expired',
  Retired: 'retired',
  Draft: 'draft',
  Custom: 'custom',
};

const ICON_DEFAULT_PROPS = {
  name: '',
  type: 'outlined',
  size: 'extra-small',
};
const BbLabel = 'bb-label';

export default {
  name: 'BbLabel',
  props: {
    view: {
      type: String,
      default: View.Text,
      validator: includesValidator(View),
    },
    status: {
      type: String,
      default: Status.Custom,
      validator: includesValidator(Status),
    },
    icon: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    classList() {
      return [BbLabel, `${BbLabel}--view-${this.view}`, `${BbLabel}--status-${this.status}`];
    },
    pointClassList() {
      return [`${BbLabel}-point`, `${BbLabel}-point--status-${this.status}`];
    },
    iconComputedProps() {
      return { ...ICON_DEFAULT_PROPS, ...this.icon };
    },
  },
};
